const enumPadding = 10;

export const calcEnumCardLayout = (size: number): number => {
    const lineHeight = 32;
    return lineHeight * size + enumPadding;
};

export const calcCategotyLayout = (size: number): number => {
    const staticHeight = 153;
    return calcEnumCardLayout(size - 1) + staticHeight - enumPadding;
};



// WEBPACK FOOTER //
// ./src/utils/calcCategoryLayout.ts